export default {
  // NOTE: name is singular
  name: 'lifeEventCategory',
  uniqKey: '_id',
  crudMapping: {
    create: 'createLifeEventCategory',
    readMany: 'lifeEventCategories',
    readOne: 'lifeEventCategory',
    update: 'updateLifeEventCategory',
    // delete: 'deleteLifeEventCategory',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
        },
        lifeEventCount: {
          title: 'Life Events',
          type: 'number',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Life Event Category',
      type: 'object',
      required: ['title', 'sortIndex'],
      properties: {
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
          description: 'Enter the description for this life event category. This field has a 280 character limit.',
          maxLength: 280,
        },
        image: {
          type: 'string',
        },
        sortIndex: {
          type: 'number',
          default: 1000,
        },
        lifeEventIds: {
          title: 'Sort Associated Life Events',
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
        },
        lifeEventThemeIds: {
          title: 'Associated Life Event Themes',
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
        },
        published: {
          type: 'boolean',
          default: true,
        },
      },
    },
    uiSchema: {
      lifeEventIds: {
        'ui:field': 'sortableField',
      },
      lifeEventThemeIds: {
        'ui:field': 'hasManyField',
      },
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/lifeEventCategory.js